<template>
    <v-dialog v-model="dialog" max-width="1200px" max-height="900px" persistent overlay-opacity="0.75">
	<v-card class="elevation-0 grey darken-3">
	<v-toolbar color="blue-grey darken-3" dark dense elevation="0">
		<!-- <v-toolbar-title>{{ cfgTable.model_title }}:</v-toolbar-title> -->
		<v-spacer />
		<v-btn class="ml-2" color="blue-grey darken-4" @click.stop="onExport()">Export</v-btn>
		<v-btn class="ml-2" color="blue-grey darken-4" @click.stop="onPrint()">Drucken</v-btn>
	</v-toolbar>
	<v-container fluid ma-0 pa-0>
	<!-- <v-toolbar flat color="blue-grey darken-1">
	</v-toolbar> -->
    <v-data-table
		:headers="cfgViews"
		:items="filteredItems"
		item-key="id"
		class="blue-grey darken-3 table-cursor"
		hide-default-footer
		:loading="loading"
		@click:row="onRowClick($event)"
    ><!---->
		<template v-for="cfgCol in cfgViews.filter((cfgCol) => cfgCol.format != 'default')"
			v-slot:[`item.${cfgCol.value}`]="{ value }">
			<span :key="cfgCol.pos" :style="styleItem(value, cfgCol.format)">{{ formatItem(value, cfgCol.format) }}</span>
		</template>

		<template v-slot:[`item.action`]="{ item }">
			<v-hover v-slot:default="{ hover }">
			<v-btn small icon :color="`${hover? 'black': 'blue-grey'}`" :class="`${hover? 'primary': 'blue-grey darken-3'}`" @click.stop="onPrintItem(item)" :loading="false" :disabled="false">
				<v-icon>print</v-icon></v-btn></v-hover>
		</template>
		<template slot="footer">
		</template>
    </v-data-table>
	<v-overlay absolute :value="loading">
		<!--<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>-->
	</v-overlay>
	</v-container>
	<v-card-actions>
		<v-btn text class="warning mx-0 mb-2" @click="onCancel()">Abbrechen</v-btn>
	</v-card-actions>
	</v-card>
    </v-dialog>          
</template>
<script>
import mixins from './helpers'
export default {
	name: 'GenericSubOverview',
	mixins: [mixins],
	components: {
	},
	props: {
		modulData: {
			type: Object,
			required: true,
			default: null,
		},
	},
	data: () => ({
		loading: false,
        dialog: false,
		cfgTable: {},
		cfgViews: [],
		items: [],
    }),
	computed: {
		filteredItems: function () {
			let self = this
			return self.items
		},
		tablename() {
			return this.modulData.meta.subviewtable
		},
	},
	methods: {
		async getData() {
            this.loading = true
			const param = {
				tablename: this.modulData.meta.subviewtable,
				parentref: 'uuid',
				parentid: this.modulData.meta.viewmodel.uuid,
			}
            try {
                await this.$store.dispatch('generic/getItems', param)
                const result = this.$store.getters['generic/getItems']( param )
                this.items = result.data
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
		},
		getCfgs() {
			let param = {
				table_name: this.modulData.meta.subtable,
				reftable: this.modulData.meta.tablename,
				view_name: this.modulData.meta.subviewtable,
			}
			if(this.reftable == 'none') { param.reftable = this.tablename }
			this.cfgTable = this.$store.getters['core/getCfgTable'](param)
			this.cfgViews = this.$store.getters['core/getCfgViews'](param)
			this.cfgViews.push({ text: 'Action', value: 'action', align: 'center', sortable: false, width: '100', class: 'blue-grey darken-4', })
		},
		onCancel() {
            this.$emit('cancel')
		},
		onPrint() {
		},
		onExport() {
		},
		onPrintItem(item) {
			const param = {
				tablename: this.modulData.meta.subviewtable,
                uuid: item.uuid,
			}
			const url = new URL(window.location.origin)
			const baseURL = url.protocol + '//' + url.hostname
			/*let path = baseURL + '/' + param.tablename + '_print?parentref=' + param.parentref + '&parentid=' + param.parentid
            path += '&year=' + param.year + '&yearweek=' + param.yearweek*/
			const path = baseURL + '/' + param.tablename + '/print?uuid=' + param.uuid
			window.open(path, "_blank")
		},
		onRowClick(e) {
			//const item = e
			//this.$router.push({ name: this.cfgTable.model_name, params: { id: item.id } })
		},
	},
	mounted() {
		this.getCfgs()
		this.getData()
        this.dialog = true
	},
	watch: {
	},
};
</script>
<style scoped>
.selected {
    background-color: red
}
.table-cursor >>> tbody tr:hover {
	cursor: pointer;
}
.text-color-red {
	color:#F44336;
	font-weight: bold;
}
.v-data-table >>> tbody tr:hover {
	/*background: transparent !important;*/
  	background: #3E5059 !important;
}
</style>